import { useAuth } from "../auth/AuthContext";

export default function SignInButton() {
  const { signIn, loading } = useAuth();
  return (
    <button className="button-primary" onClick={signIn} disabled={loading}>
      {loading ? "Signing in..." : "Sign in with Google"}
    </button>
  );
}
